(() => {
    // let isCheckout;
    // if (typeof wc_checkout_params === 'undefined') {
    //     isCheckout = false;
    // } else {
    //     isCheckout = !!wc_checkout_params.is_checkout;
    // }
    // if (!isCheckout) return;
    // const method = document.querySelector('input[name="payment_method"]');
    // document.addEventListener('$updated_checkout', () => {
    //     console.log('yes');
    //     setTimeout(() => {
    //         method.style = '';
    //     }, 0);
    // });
})();
